import { useCallback } from 'react';

import * as events from 'utils/events';

/**
 * custom hook handler to call input event when the user clicks the left mouse button
 * @param onClick *event to trigger upon successful left click
 */
export default function useMousLeftClick(onClick: (e: React.MouseEvent) => void) {
  return useCallback((e: React.MouseEvent) => events.onMouseLeftClick(onClick)(e), [onClick]);
}
